/* eslint-disable */
import React from 'react'
export const APP = {
  name: 'به‌روزمارت',
  color: '#b2d234'
}

export const baseURL = 'https://dispatch.beroozmart.com/Beroozresan/rest/';             //server asli
// export const baseURL = 'http://192.168.77.122:8383/Beroozresan/rest/';            //server asli
// export const baseURL = 'http://192.168.7.174/Beroozresan/rest/';            //server asli
// export const baseURL = 'http://127.0.0.1:8080/Beroozresan/rest/';            //server asli
// export const baseURL = 'http://192.168.77.117:8080/Beroozresan/rest/';            //sadeghi
// export const baseURL = 'http://192.168.7.129:8080/Beroozresan/rest/';            //sadeghi
export const shopUrl = 'https://beroozmart.com'
export const adminShopUrl = 'https://admin.beroozmart.com'



export const loadBrand = () => {
  return {
    logo: require('../../image/branding/logo-outline-fa.svg'),
    title: APP.name,
    color: APP.color
  }
}
